import SubmissionsView from './SubmissionsView';

export default SubmissionsView;
